import { RefObject } from 'react';

interface ButtonRef {
  current: HTMLButtonElement;
}

export const hasRefs = (
  chipRefs: RefObject<HTMLButtonElement>[]
): chipRefs is ButtonRef[] => chipRefs.every(c => !!c.current);

interface FindChipProps {
  chipRefs: ButtonRef[];
  direction: 'left' | 'right';
  scrollLeft: number;
  containerWidth: number;
}

type CalcDistance = (
  current: HTMLButtonElement,
  scrollLeft: number,
  containerWidth: number
) => number;

const getRightDistance: CalcDistance = (current, scrollLeft, containerWidth) =>
  scrollLeft + containerWidth - current.offsetLeft - current.offsetWidth;

const getLeftDistance: CalcDistance = (current, scrollLeft) =>
  scrollLeft + current.offsetWidth - current.offsetLeft;

export const findChip = ({
  chipRefs,
  direction,
  scrollLeft,
  containerWidth,
}: FindChipProps) => {
  const calcDistance: CalcDistance =
    direction === 'right' ? getRightDistance : getLeftDistance;

  const [chip] = chipRefs.reduce((res, chip) => {
    const distance = calcDistance(chip.current, scrollLeft, containerWidth);

    if (!res[0] || (distance >= 0 && distance < res[1])) {
      return [chip, distance];
    }
    return res;
  }, [] as unknown as [ButtonRef, number]);

  return chip;
};
